/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Button from "@mui/material/Button";
import MDTypography from "components/MDTypography";
import { forwardRef, useImperativeHandle, useState } from "react";

const InformacionAdicional2 = forwardRef(
  ({ Back, Next, props, vista = "registrar", desactivar }, ref) => {
    //informacion adicional
    const [textInfo, setTextInfo] = useState(props?.infoAdicional ? props.infoAdicional : "");

    const ValidaForm = () => {
      var data = {
        infoAdicional: textInfo,
      };
      Next(data);
      return data;
    };

    const ValidaForm2 = () => {
      var data = {
        infoAdicional: textInfo,
      };
      Back(data);
      return data;
    };

    //Métodos para guardar los datos editados:
    useImperativeHandle(ref, () => ({
      ejecutarNext: () => {
        return ValidaForm();
      },
    }));

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3} lg={3}>
            <MDBox textAlign="right">
              <MDTypography variant="h6" color="white" style={{ opacity: 0.7, fontSize: "0.9rem" }}>
                Informacion adicional
              </MDTypography>
            </MDBox>
          </Grid>
          <Grid item xs={12} md={9} lg={9}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  value={textInfo}
                  onChange={(event) => {
                    setTextInfo(event.target.value);
                  }}
                  label={"Ingrese información adicional"}
                  disabled={desactivar}
                  variant="outlined"
                  style={{ width: "100%", marginBottom: "1.5rem" }}
                  multiline
                  rows={8}
                  size="small"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {vista === "visualizar" ? null : (
          <MDBox textAlign="right">
            <Button
              variant="contained"
              onClick={() => ValidaForm()}
              sx={{ mt: 1, mr: 1 }}
              size="small"
              color="primary"
            >
              {"Registrar solicitud"}
            </Button>
            <Button
              variant="contained"
              disabled={false}
              onClick={() => ValidaForm2()}
              sx={{ mt: 1, mr: 1 }}
              color="secondary"
              size="small"
            >
              Volver
            </Button>
          </MDBox>
        )}
      </>
    );
  }
);
export default InformacionAdicional2;
